let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kq6VC")).then(() => parcelRequire('hjISk'));